import { LocalStorageAccessor } from '../../StorageAccessor/LocalStorageAccessor';

export class RecommendationsCache {
    private static readonly recommendationsKey = 'recommendations';

    public static saveRecommendations = (key: string, recommendations: string) => {
        LocalStorageAccessor.setItem(key + ':' + this.recommendationsKey, recommendations);
    };

    public static getRecommendations = (key: string): string | null => {
        return LocalStorageAccessor.getItem(key + ':' + this.recommendationsKey) || null;
    };
}
